import { memo } from 'react';
import { CalendarEventTemplateAgenda } from './CalendarEventTemplateAgenda';
import { CalendarEventTemplateWeek } from './CalendarEventTemplateWeek';
import { Stack, Tooltip, Typography } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CalendarEventTemplate = memo((props: any) => {
  const { currentView, IsAllDay } = props;
  if (IsAllDay)
    return (
      <Tooltip title={props.Subject}>
        <Stack
          flexDirection="row"
          sx={{
            height: 'inherit',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
            justifyItems: 'center',
          }}
        >
          <Typography
            sx={{
              color: 'inherit',
              width: 'inherit',
              height: 'fit-content',
              textOverflow: 'ellipsis',
            }}
            variant="subtitle1"
            fontWeight="bolder"
            style={{ flex: 1, textAlign: 'center' }}
          >
            {props.Subject}
          </Typography>
        </Stack>
      </Tooltip>
    );

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {currentView === 'Agenda' ? (
        <CalendarEventTemplateAgenda {...props} />
      ) : (
        <CalendarEventTemplateWeek {...props} />
      )}
    </>
  );
});
